import $ from "jquery";

//import jQueryResizeDom from "jquery-resizable-dom";
require("jquery-ui/ui/widgets/resizable");
require("jquery-ui/ui/widgets/tabs");
require("jquery-ui/ui/widgets/dialog");
require("/assets/js/jquery.dragscroll");

require("jquery-ui/themes/base/images/ui-bg_flat_0_aaaaaa_40x100.png");
require("jquery-ui/themes/base/images/ui-icons_444444_256x240.png");
require("jquery-ui/themes/base/images/ui-icons_555555_256x240.png");
require("jquery-ui/themes/base/images/ui-icons_777620_256x240.png");
require("jquery-ui/themes/base/images/ui-icons_777777_256x240.png");
require("jquery-ui/themes/base/images/ui-icons_cc0000_256x240.png");
require("jquery-ui/themes/base/images/ui-icons_ffffff_256x240.png");

import "/assets/js/jquery.panFullSize";

import showAreaChart from "/assets/js/AreaChart";
import {
  loadCurrentSlide,
  loadPreviousSlide,
  loadNextSlide,
  insertTextPageHis,
} from "/assets/js/textPage";
import { updateIsMustReviewFlg } from "/assets/js/star-button";
import ace from "brace";
import "brace/theme/eclipse";
import "brace/mode/pgsql";
import "brace/mode/java";
import "brace/ext/language_tools";

import toastr from "toastr";

window.showAreaChart = showAreaChart;
window.loadCurrentSlide = loadCurrentSlide;
window.loadPreviousSlide = loadPreviousSlide;
window.loadNextSlide = loadNextSlide;

window.insertTextPageHis = insertTextPageHis;
window.updateIsMustReviewFlg = updateIsMustReviewFlg;

window.toastr = toastr;
import "toastr/build/toastr.min.css";
